<template>
  <a-modal 
    :title="title" 
    :visible="hidden"
    @ok="ok" 
    @cancel="cancel"
    :forceRender="true"
    :destroyOnClose="true"
    :maskClosable="false"
    width="800px"
    okText="确定"
    cancelText="取消">
    <a-form-model
      ref="ruleForm"
      class="create-form"
      :model="form"
      :rules="rules"
      :validateOnRuleChange="true"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="配方名称" prop="formulaName">
        <a-input @change="checkNameLen" size="small" placeholder="输入配方名称" v-model.trim="form.formulaName" />
      </a-form-model-item>
      <a-form-model-item label="动物类型" prop="animal">
        <a-cascader 
          ref="cascader"
          :options="animal"
          :load-data="loadAnimalData"
          @change="onChange"
          size="small"
          :placeholder="formValue.animal"
        />
      </a-form-model-item>
      <a-form-model-item label="配方模型"  prop="modelId">
        <a-select
          @select="modelChange"
          placeholder="选择配方模型"
          :allowClear="true"
          @change="modelSelect"
          v-model="form.modelId"
        >
          <a-select-option v-for="(item,index) in model.records" :key="index" :title="item.name" :value="item.id">
            {{item.name}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label=" "  :colon="false">
        <a-radio-group v-model="form.isFilledModel">
          <a-radio :value="0">模型不填充配方</a-radio>
          <a-radio :value="1">模型填充配方</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="养分选择表"  prop="linkId">
        <a-select
          @change="nutritionChange"
          placeholder="选择养分表"
          :defaultValue="defaultNutrition"
          :allowClear="true"
          v-model="form.linkId"
        >
          <a-select-option v-for="(item,index) in nutrition.records" :title="item.name" :key="index" :value="item.id">
            {{item.name}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="价格来源" prop="priceSource">
        <a-select placeholder="选择价格来源" v-model="form.priceSource" :options="priceOption" />
      </a-form-model-item>
      <a-form-model-item label="设定盘重" prop="totalWeight">
        <a-space type="flex">
        <a-input-number style="flex:1;" step="1" size="small" type="number" v-model="form.totalWeight">
        </a-input-number><span>KG</span></a-space>
      </a-form-model-item>
      <!-- "moistureVolatilizeStart": 0,
      "moistureVolatilizeUtil": 0, -->
      <a-form-model-item label="水分挥发" prop="moistureVolatilizeStart">
        <a-space type="flex">
        <a-input-number step="0.01" size="small" type="number" :min="0" :max="100"  @change="startChange" v-model="moistureVolatilizeStart">
        </a-input-number><span>%</span></a-space>
      </a-form-model-item>
      <!-- <a-form-model-item label="水分挥发直到" prop="moistureVolatilizeUtil">
        <a-space type="flex">
        <a-input-number step="0.01" size="small" :min="0" :max="100" @change="utilChange"  type="number" v-model="moistureVolatilizeUtil">
        </a-input-number><span>%干物质</span></a-space>
      </a-form-model-item> -->
      <a-form-model-item label="分析基础" prop="analysisBase">
        <a-space>
        <a-input-number size="small" v-model="form.analysisBase" :disabled="true">
        </a-input-number>
        <span>KG</span>
        </a-space>
      </a-form-model-item>
      <a-form-model-item ref="remark" label="备注" prop="remark">
        <a-textarea size="small" v-model="form.remark" placeholder="输入备注" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import {nhfMixins} from '../../untils'

export default {
  props:['hidden'],
  mixins:[nhfMixins],
  data(){
    return {
      modelCache:[],
      formValue:{
        model:'选择配方模型',
        animal:'选择动物类型',
        price:'选择价格来源'
      },
      nutrition:{
        records:[],
      },
      animal:[],
      title:'添加配方',
      form:{
        totalWeight:1000,
        analysisBase:1,
        analysisBaseUnit:'Kg',
        priceSource:'4',
        isFilledModel:0,
      },
      moistureVolatilizeStart:null,
      moistureVolatilizeUtil:null,
      rules: {
        // formulaCode: [{ required: true, validator:this.validatorCode, trigger: 'blur' }],
        formulaName: [{ required: true, message: '请输入配方名称', validator: this.validatorName, trigger: 'blur' }],
        animal: [{ required: true, message: '请选择动物类型',validator: this.validatorAnimal, trigger: 'blur' }],
        // modelId: [{ required: true, message: '选择配方模型', trigger: 'change' }],
        priceSource: [{ required: true, message: '选择价格来源', trigger: 'change' }],
        linkId: [{ required: true, message: '选择养分', trigger: 'change' }],
        totalWeight: [{ required: true, message: '请输入盘重设定', trigger: 'change' }]
      },
      checkTitle: '',
      maxLen: 31
    }
  },
  computed:{
    defaultModel(){
      return this.form && this.form.model && this.form.model.records && this.form.modelId ? this.model.records.filter(i=>i.id === this.form.modelId)[0].name : null
    },
    defaultNutrition(){
      return this.form && this.form.linkId  && this.form.linkId ? this.nutrition.records.map(i=>i.id === this.form.linkId)[0].name : null
    },
    animalDefault(){
      return [this.form ? this.form.animalTypeCode : null]
    }
  },
  mounted(){
    this.factoryId = window.localStorage.getItem('factoryId')
    const {id} = this.$route.query
    this.formulaId = id
    this.getModelList()
    this.getNutrition()
    this.initAnimal()
  },

  watch:{
    hidden(val){
      if(val && this.formulaId){
        this.title="编辑配方"
        this.formValue.price = '市场价格'
        this.detailInit()
        // this.initAnimal()
      }
    },
  },
  
  methods:{
    getCharLen(str=''){
      let len = 0
      let strArr = str.split('')
      strArr && strArr.forEach(el => {
        if(el.charCodeAt() > 255){
          len += 3
        }else{
          len++
        }
        if(len <= this.maxLen){
          this.checkTitle += el
        }
      })
      return len
    },
    checkNameLen(e){
      let val = e.target.value
      this.checkTitle = ''
      let len = this.getCharLen(val)
      if(len > this.maxLen){
        this.form.formulaName = this.checkTitle
        this.$message.warning(`配方名称长度不能超过${this.maxLen}个字节`)
      }
    },
    startChange(val){
      if(val>0){
        this.moistureVolatilizeUtil = null
      }
    },
    utilChange(val){
      if(val>0){
        this.moistureVolatilizeStart = null
      }
    },
    validatorName(rule, value, callback) {
      let msg = ''
      // let flag = false
      // let reg2 = /[`/\\~!@$^&_+=<>?:"{}|^%,;'[\]·~！@￥……&——+={}|《》？：“”【】、；‘’，。、]/im;
      // [] ： * ?< > / \ 、
      let reg2 = /[*[\]：？<>/、\\.]/im;
      if(reg2.test(value)){
        // msg = `配方名称不能包含\`/\\~!@$^&_+=<>?:"{}|^%,;'[]·~！@￥……&——+={}|《》？：“”【】、；‘’，。、等特殊字符`
        // flag = true
        msg = '配方名称不能包含*[]：？<>/、\\.等特殊字符'
      }
      // 长度
      // let len = this.getCharLen(value)
      let len = value.length
      if(len > this.maxLen2){
        msg = `配方名称长度不能超过${this.maxLen2}个字符`
      }
      if(msg) callback(new Error(msg))
      callback()
    },
    validatorAnimal(rule,value,callback){
     const { animalRootId, animalTypeCode, animalTypeName} = this.form
      if( !animalRootId && !animalTypeCode && !animalTypeName){
        callback(new Error("请选择动物"))
      }
      callback()
    },
    async validatorCode(rule,formulaCode,callback){
      let pattern =/^[A-Za-z0-9]+$/
      if(formulaCode.length){
        if(!pattern.test(formulaCode)){
          callback(new Error('配方代码只能由数字和字母组成'))
          return
        }
        const result = await this.fetchPost({
          actions:this.checkFormulaCodeIsUnique,
          showMessage:false,
          data:{
            formulaCode
          }
        })
        result ? callback() : callback(new Error('配方代码重复'))
      }else{
       callback(new Error('请输入配方代码')) 
      }
    },
    nutritionChange(val){
      this.form.linkId = val
    },
    async detailInit(){
      await this.getDetail()
      this.$nextTick(()=>{
        let mo = this.model.records.filter(i=>i.id === this.form.modelId)[0]
        this.formValue.model = mo ? mo.name : null
        this.formValue.animal = this.form.animalTypeName
        this.formValue.animalTypeName = this.form.animalTypeName
        this.form.animal= [this.form.animalTypeCode]
        this.form.modelId = this.form.modelId ? this.form.modelId : undefined

        this.moistureVolatilizeStart = this.form.moistureVolatilizeStart
        this.moistureVolatilizeUtil = this.form.moistureVolatilizeUtil

      })
      if(!this.model.records || this.model.records.length === 0) await this.getModelList()
    },
    async getDetail(){
      await this.fetchGet({
          showMessage:false,
        actions:this.formulaRawNhfDetail,
        name:'form',
        data:{
          formulaId:this.formulaId,
        }
      })
    },
    getNutrition(arg ={}){
      this.fetchGet({
          showMessage:false,
        actions:this.animalNutritionUserPage,
        name:'nutrition',
        data:{
          ...arg,
          size:1000
        }
      })
    },

    animalChange(val){
      if(val && val.length > 0){
        const {name,id} =[...val].pop()
        const {id:animalRootId} =[...val].shift()
        this.form.animalTypeName = name
        this.form.animalTypeCode = id
        this.form.animalRootId = animalRootId
      } else{
        this.form.animalTypeName = undefined
        this.form.animalTypeCode = undefined
        this.form.animalRootId = undefined
      }
    },

    modelSelect(val){
      if(val === undefined) {
        this.form.modelId = ''
      }
    },

    modelChange(val){
      this.form.isFilledModel = 0
      const item = this.model.records.filter(i=>i.id === val)[0]
      const {id} = item
      this.form.modelId = id
    },

    async getModelList(arg={}){
      await this.fetchGet({
          showMessage:false,
        actions:this.formulaModel,
        data:{
          size:300,
          current:1,
          ...arg
        },
        name:'model'
      })
      if(this.model.records.length === 0) {
        this.model.records = this.modelCache
      } else {
        this.modelCache = JSON.parse(JSON.stringify(this.model.records))
        this.formValue.model = '选择配方模型'
      }
    },

    // 创建配方
    ok(){
      this.$refs.ruleForm.validate( async (valid) => {
        if (valid) {
          const {type} = this.$route.query
          const { moistureVolatilizeStart, moistureVolatilizeUtil} = this
          const {analysisBase,analysisBaseUnit,animalTypeCode,animalTypeName,totalWeight,formulaName,factoryId,id,modelId,remark,priceSource,linkId,isFilledModel,animalRootId} = this.form
          const resData = {analysisBase,analysisBaseUnit,animalTypeCode,animalTypeName,totalWeight,formulaName:formulaName.replace(/\s*/g,""),factoryId,modelId,remark,priceSource,linkId,isFilledModel,formulaType:  type||1 ,animalRootId,moistureVolatilizeStart,moistureVolatilizeUtil}
          if(id) resData.id = id
          this.cleanForm()
          this.$emit('ok',resData)
        } else {
          return false
        }
      })
    },

    cancel(){
      this.cleanForm()
      this.$emit('cancel')
    },

    cleanForm(){
      this.$refs.ruleForm.resetFields()
      this.form = {
        totalWeight:1000,
        analysisBaseUnit:'Kg',
        analysisBase:1,
        isFilledModel:0,
        priceSource:'4'
      }
      this.formValue = {
        model:'选择配方模型',
        animal:'选择动物类型',
      }
    },

    onChange(val,select){
      this.animalChange(select,val)
    },

    mapFilter (i) {
      return {
        ...i,
        label:i.name,
        value:i.id,
        isLeaf: !i.hasChildren
      } 
    },

    async loadAnimalData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      const {value:parentId} = targetOption
      let factoryId = window.localStorage.getItem('factoryId')
      const res = await this.animalTypeList({parentId,factoryId})
      targetOption.loading = false
      targetOption.children = res.data.map(this.mapFilter)
      this.animal = [...this.animal]
    },

    async initAnimal(){
      let factoryId = window.localStorage.getItem('factoryId')
      const res = await this.animalTypeList({parentId:0,factoryId})
      const {data} = res
      if(data && data.length && data[0].id){
        const resAnimal = await this.animalTypeList({parentId:data[0].id,factoryId})
        this.animal = resAnimal.data.map(this.mapFilter)
      } else{
        this.animal = res.data.map(this.mapFilter)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .ant-form-item{
    margin-bottom: 0;
  }
  ::v-deep .ant-space-item{
      font-size: 12px;
  }
</style>
